export default "/fcbcac1db17390110677298f9d30eeed9c121039/b552ae94a3baa9664c4076d726380c66.svg";